export const DEFAULT_SUSPENSE = true
